import localStorage from 'react-use-localstorage';

export const useLocalStorage = localStorage;